module.exports = __webpack_public_path__ + "media/fonts/SFProText-Bold-cbf9ad5262b20dde960adefcdaae5187.ttf";